import React from 'react';
import PropTypes from 'prop-types';
import StarField from '../UI/StarField';

const Label = ({ className, title, isMandatory }) => (
    <label className={className}>
        {title}
        {isMandatory && <StarField />}
    </label>
);

Label.propTypes = {
    title: PropTypes.string.isRequired, // Title is required
    isMandatory: PropTypes.bool,       // Whether the label is mandatory
    className: PropTypes.string,       // Optional class name
};

Label.defaultProps = {
    isMandatory: false, // Default to non-mandatory
    className: '',      // Default to an empty string for className
};

export default Label;
